import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faAngleUp as fasAngleUp,
  faAngleDown as fasAngleDown,
  faSignOutAlt,
  faFileDownload,
  faFileAlt,
  faCheckCircle,
  faBarcode,
  faPortrait,
  faLaptop,
  faWrench,
  faCloudUploadAlt,
  faPlusSquare,
  faEye,
  faFileExcel,
  faDownload,
  faPencilRuler,
  faTools,
  faPlusCircle,
  faMoneyBill,
  faClipboardList,
  faAddressBook,
  faFileInvoiceDollar,
  faRedo,
  faExclamationTriangle,
  faReceipt,
  faInfoCircle,
  faShieldAlt,
  faCog,
  faEdit,
  faTrash,
  faPaperPlane,
  faChartBar,
  faTimes,
  faChevronDown,
  faFilePdf,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  fasAngleUp,
  fasAngleDown,
  faSignOutAlt,
  faFileDownload,
  faFileAlt,
  faCheckCircle,
  faEye,
  faBarcode,
  faPortrait,
  faLaptop,
  faWrench,
  faCloudUploadAlt,
  faPlusSquare,
  faFileExcel,
  faDownload,
  faPencilRuler,
  faTools,
  faPlusCircle,
  faMoneyBill,
  faClipboardList,
  faAddressBook,
  faFileInvoiceDollar,
  faRedo,
  faExclamationTriangle,
  faReceipt,
  faInfoCircle,
  faShieldAlt,
  faCog,
  faEdit,
  faTrash,
  faPaperPlane,
  faChartBar,
  faTimes,
  faChevronDown,
  faFilePdf
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
